// extracted by mini-css-extract-plugin
export default {"autoResizeTextarea":"AutoResizeTextarea_autoResizeTextarea__Xvdi4"};